<script setup lang="ts">
import type {PageCollectionItemBase} from "@nuxt/content";

const {collectionUri} = useI18nCollection();
const {getIndex, getAllButIndex} = usePage();
const pages: PageCollectionItemBase[] = await queryCollection(collectionUri('brands')).all();
const index = getIndex(pages)!;
const entries = getAllButIndex(pages).sort((a, b) => (a.meta?.order || 0) - (b.meta?.order || 0)).slice(0, 4);
const config = useRuntimeConfig().public;
</script>

<template>
  <section id="marques" class="container scroll-mt-20">
    <div class="bg-light block-round p-8 tablet:p-8 laptop:p-10">
      <ul role="list" class="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-10 tablet:max-w-none tablet:grid-cols-2 laptop:grid-cols-3">
        <li
          v-for="item in entries"
          :key="item.path"
          class="text-brand-dark"
        >
          <picture class="w-full relative block aspect-[3/2] rounded-2xl overflow-hidden outline-1 -outline-offset-1 outline-black/5">
            <media-source
              :uri="(item.meta?.image as string || '').replace('/assets', '')"
              :expose-only="false"
              :dimensions="[
                { width: 2560 },
                { width: 1920 },
                { width: 1400 },
                { width: 720 }
              ]"
              sizes="100vw"
              :media="`(min-width: ${config.ui.breakpoints.tablet.width}px)`"
              format="webp"
              as="source"
            />
            <media-source
              :uri="(item.meta?.image as string || '').replace('/assets', '')"
              :expose-only="false"
              :dimensions="[
                { width: 2560 },
                { width: 1920 },
                { width: 1400 },
                { width: 720 }
              ]"
              sizes="100vw"
              format="jpg"
              as="img"
              class="w-full h-full object-cover"
            />
          </picture>
          <h3 class="mt-4 text-lg font-semibold tracking-tight">{{ item.title }}</h3>
          <p v-if="item.meta?.subtitle" class="text-base opacity-75">{{ item.meta.subtitle }}</p>
          <ContentRenderer :value="item" class="text-base opacity-75 with-free-text" />
        </li>
      </ul>
      <footer v-if="index?.meta?.brandCta" class="mt-10 text-center flex gap-x-3">
        <ButtonCta v-for="cta in index.meta.brandCta" :key="cta.label" :cta="cta" />
      </footer>
    </div>
  </section>
</template>
